import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ChildrenInfoStep = ({ formData, errors, onChildChange, onAddChild, onRemoveChild }) => {
  const ageOptions = Array.from({ length: 15 }, (_, i) => ({
    value: (i + 12)?.toString(),
    label: `${i + 12} ans`
  }));

  const gradeOptions = [
    { value: 'sixieme', label: 'Sixième (6ème)' },
    { value: 'cinquieme', label: 'Cinquième (5ème)' },
    { value: 'quatrieme', label: 'Quatrième (4ème)' },
    { value: 'troisieme', label: 'Troisième (3ème)' },
    { value: 'seconde', label: 'Seconde (2nde)' },
    { value: 'premiere', label: 'Première (1ère)' },
    { value: 'terminale', label: 'Terminale' }
  ];

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      <div className="bg-green-50 border border-green-200 rounded-lg p-4 md:p-5 lg:p-6">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-green-500 rounded-full flex items-center justify-center">
            <span className="text-white text-sm md:text-base lg:text-lg font-semibold">2</span>
          </div>
          <div>
            <h3 className="text-base md:text-lg lg:text-xl font-semibold text-gray-900 mb-1 md:mb-2">
              Informations sur vos Enfants
            </h3>
            <p className="text-sm md:text-base text-gray-600">
              Ajoutez les informations de vos enfants pour un suivi personnalisé.
            </p>
          </div>
        </div>
      </div>

      {formData?.children?.map((child, index) => (
        <div key={index} className="p-5 bg-gray-50 rounded-lg border border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <h4 className="font-semibold text-gray-900">Enfant {index + 1}</h4>
            {formData?.children?.length > 1 && (
              <button
                onClick={() => onRemoveChild(index)}
                className="text-red-600 hover:text-red-700 text-sm font-medium flex items-center gap-1"
              >
                <Icon name="Trash2" size={16} />
                Retirer
              </button>
            )}
          </div>

          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input
                label="Prénom"
                type="text"
                placeholder="Prénom de l'enfant"
                value={child?.firstName}
                onChange={(e) => onChildChange(index, 'firstName', e?.target?.value)}
                error={errors?.[`child${index}FirstName`]}
                required
              />

              <Input
                label="Nom de Famille"
                type="text"
                placeholder="Nom de l'enfant"
                value={child?.lastName}
                onChange={(e) => onChildChange(index, 'lastName', e?.target?.value)}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Select
                label="Âge"
                options={ageOptions}
                value={child?.age}
                onChange={(value) => onChildChange(index, 'age', value)}
                placeholder="Sélectionnez l'âge"
                error={errors?.[`child${index}Age`]}
                required
              />

              <Select
                label="Niveau d'Études"
                options={gradeOptions}
                value={child?.grade}
                onChange={(value) => onChildChange(index, 'grade', value)}
                placeholder="Sélectionnez le niveau"
                error={errors?.[`child${index}Grade`]}
                required
              />
            </div>

            <Input
              label="Établissement Scolaire"
              type="text"
              placeholder="Nom de l'école ou lycée"
              value={child?.school}
              onChange={(e) => onChildChange(index, 'school', e?.target?.value)}
            />
          </div>
        </div>
      ))}

      <Button
        variant="outline"
        onClick={onAddChild}
        iconName="Plus"
        iconPosition="left"
        className="w-full"
      >
        Ajouter un Autre Enfant
      </Button>
    </div>
  );
};

export default ChildrenInfoStep;